import React from "react";
import { useNavigate } from "react-router-dom";

const ComingSoon = () => {
  const navigate = useNavigate();

  return (
    <div className="h-[80vh] flex items-center justify-center">
      <div className="flex items-center justify-center w-full">
        <div className="max-w-md text-center">

          {/* Logo Circle */}
          <div className="mx-auto mb-8 flex h-28 w-28 items-center justify-center rounded-full bg-gradient-to-br from-[#c51369] to-[#f54ea2] shadow-xl">
            <span className="text-5xl font-bold text-white">🎉</span>
          </div>

          {/* Heading */}
          <h1 className="text-4xl font-extrabold text-gray-900 mb-3">
            Coming{" "}
            <span className="bg-gradient-to-r from-[#c51369] to-[#f54ea2] bg-clip-text text-transparent">
              Soon
            </span>
          </h1>

          {/* Subtext */}
          <p className="text-lg text-gray-600 leading-relaxed mb-10">
            We’re working hard to bring you this feature.
            Stay tuned for updates!
          </p>

          {/* Buttons */}
          <div className="flex justify-center gap-4">
            <button
              onClick={() => navigate(-1)}
              className="w-32 rounded-full border border-[#c51369] px-6 py-3 text-[#c51369] transition-all duration-300 hover:bg-[#c51369] hover:text-white"
            >
              Go Back
            </button>

            <button
              onClick={() => navigate("/")}
              className="w-32 rounded-full bg-gradient-to-r from-[#c51369] to-[#f54ea2] px-6 py-3 text-white transition-all duration-300 hover:opacity-90"
            >
              Home
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
